import {Component, Injector, OnInit, ViewChild} from '@angular/core';
import {CurrentLandlordModel} from '@core/model/landlord.model';
import {LandlordPropertyModel} from '@core/model/landlordProperty.model';
import {LandlordsService} from '@core-services/landlords.service';
import {MatPaginator} from '@angular/material/paginator';
import {FormControl, FormGroup} from '@angular/forms';
import {BasePageComponent} from '@core-components/page-content/base-page.component';
import {User} from "@ui-kit/framework/security/model/user.model";
import {ConsoleContextService} from "@security/console-context.service";

@Component({
  selector: 'app-global-settings',
  templateUrl: './global-settings.component.html',
})
export class GlobalSettingsComponent extends BasePageComponent implements OnInit {

  loggedInUser: User | null;
  currentLandlord: CurrentLandlordModel | null = null;
  properties: LandlordPropertyModel[] = [];
  filterForm: FormGroup;

  @ViewChild('paginator') paginator!: MatPaginator;


  constructor(injector: Injector,
               contextService: ConsoleContextService,
               landlordService: LandlordsService) {
    super(injector);
    this.loggedInUser = contextService.currentUser;
    contextService.getCurrentWebClient()
      .then((landlord: CurrentLandlordModel | null) => {
        this.currentLandlord = landlord;
        landlordService.getPropertiesForLandlord(landlord!.uuid)
          .then((propertyList: LandlordPropertyModel[]) => {
            this.properties = propertyList;
          })
      });
    this.filterForm = new FormGroup({
      eventType: new FormControl(null),
      eventId: new FormControl(null)
    })
  }

  ngOnInit() {
  }

}
